import React from 'react';
import Teams from '../editor/teams/teams';

function EmailTeams() {
  return (
    <Teams teamsUrl="/email_teams"/>
  );
}

export default EmailTeams;
